import React from "react";
import Modal from 'react-bootstrap/Modal';
import AutoComplete1 from "../../Utils/GenericUI/Select";

const LoadApplModal = (props) => {
    return (
        <Modal
            show={props.showModal}
            onHide={props.modalClose}
            //size={this.state.expand ? "xl" : "lg"}
            size="lg"
            centered
            scrollable={true}
            backdrop="static"
        >
            <Modal.Header className="modal-header-background">
                <Modal.Title>
                    Continue Previous Applications
                </Modal.Title>
                <button type="button" class="close" onClick={props.modalClose}>&times;</button>
            </Modal.Header>

            <Modal.Body>
                {
                    props.agentLoggedIn === false && props.pendingAppList?.length > 0 ?
                        <div class="row mb-3">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <AutoComplete1
                                    handleChange={props.handleChangeYear("appNum")}
                                    label="Pending Applications"
                                    options={props.pendingAppList}
                                    // disabled = "true"
                                    defaultValue={props.pendingAppList.find(
                                        (data) => data.value === props.appNum
                                    )}
                                    value={props.pendingAppList.find(
                                        (data) => data.value === props.appNum
                                    )}
                                    name="Pending Applications"
                                    margin="20px auto"
                                    width="100%"
                                />
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 text-center">

                                <button
                                    class={"btn-primary-continue mb-3"}
                                    onClick={props.redirect}
                                    disabled={props.appNum==="" || props.appNum==="Select"}
                                >
                                    Continue
                                </button>

                            </div>
                        </div>
                        : null
                }
            </Modal.Body>
        </Modal>
    )
}
export default LoadApplModal;